import { Col, Rate, Row, Spin, Typography } from 'antd';
import React, { FC, useState } from 'react';
import styled from 'styled-components';
import { ExpertText, MediumHeaderTitle, SmallText } from '../../../Components/Text3D';
import Ultimaker from '../../../assets/images/ultimaker.png';
import { PrimaryButton } from '../../../Components/Button3D';
import { useHistory, useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { GET_SINGLE_PRINTER } from '../../../Apollo/graphql/Query';

const MainWrapper = styled(Row)`

/* &:before{
      content: "";
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 20px solid white;
      margin-left: 360px;
    } */
`


const ContentWrapper = styled(Col)`
    display: flex;
    flex-direction: column;
    padding: 2rem;
    background: white;
    font-family: "Rogan", -apple-system, BlinkMacSystemFont, sans-serif;
`
const TopContent = styled(Col)`
    border-bottom: 1px solid #D8D8D8;
    padding-bottom: 1rem;
`;
const ContentSection = styled.div`
    display: flex;
    flex-direction: column;
`
const ImageSection = styled.div`
    display: flex;
    height: 360px;
    justify-content: center;
    align-items: center;
    width: 100%;
    border: 1px solid #D8D8D8;
    margin: 1rem 0;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.16);
`;
// const Img = styled.img`
//     margin: 1rem auto;

// `;
const Img = styled.img`
  margin: 1rem auto;
  display: inline-block;
  max-width: 100%;
  height: 100%;
`
const ThumbnailImgSection = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
`
const ThumbnailImgWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #D8D8D8;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.16);
    height: 122px;
    width: 114px;
`
const ThumbnailImg = styled.img`
    height: 80px;
    width: 70px;
`;
const RightContentSection = styled.div`
    width: 100%;
    padding: 2rem;
`;
const ContentDiv = styled.div`
    width: 80%;
    display: flex;
    flex-direction: column;
    margin-left: 1rem;
`
const SpanX = styled.span`
    margin-left: 1rem;
`
// const RatingDiv = styled.div`
//     display: flex;
//     border-top: 1px solid #D8D8D8;
//     border-bottom: 1px solid #D8D8D8;
//     height: 50px;
//     align-items: center;
// `
const SectionX = styled.section`
    font-family: "Rogan", -apple-system, BlinkMacSystemFont, sans-serif;
    font-size: 16px;
    color: #75706B;
    display: flex;
`
const SubHeaderDiv = styled.div`
    border-top: 1px solid #D8D8D8;
    padding-top: 1rem;
`;
const DivImage = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 2rem 4rem;
    border-bottom: 1px solid #D8D8D8;
`;
const InfoDiv = styled(Row)`
    padding: 1rem 0;
    border-bottom: 1px solid #D8D8D8;
`;
const RatingSection = styled.div`
    padding: 1rem 0;
`;
const SectionA = styled.div`
    font-family: "Rogan", -apple-system, BlinkMacSystemFont, sans-serif;
    font-size: 16px;
    color: #75706B;
    display: flex;
    align-items: center;
`;
const ReviewDiv = styled.div`
    background: #F7F7F7;
    height: 65px;
    display: flex;
    align-items: center;
    padding-left: 1rem;
    margin-top: .5rem;
`
const ReviewSection = styled(Row)`
    
`
const Reviews = styled.div`
    padding-bottom: 1rem;

`
interface FPrinter {
    name?: string
    brand?: string
    height?: number
    width?: number
    length?: number
    weight?: number
    price?: number
    featuredImage?: string
    material?: string
    // supportedFiles?

}
const SinglePrinterPage: FC = () => {
    const history = useHistory();
    const { id } = useParams<{ id?: string }>();
    const [printer, setPrinter] = useState<FPrinter>({});

    const { loading } = useQuery(GET_SINGLE_PRINTER, {
        variables: {
            printerId: id
        },
        onCompleted: data => {
            setPrinter(data?.printer);
        },
        onError: (err) => {
            console.log("something went wrong")
        }
    });

    return (
      <Spin spinning={loading}>
        <MainWrapper>
          <ContentWrapper>
            <TopContent>
              <ExpertText dark>
                Dashboard / My Printers / <a href="main">{printer.name}</a>
              </ExpertText>
            </TopContent>
            <Row
              style={{
                borderBottom: "1px solid #D8D8D8",
                paddingBottom: "2rem",
              }}
            >
              <Col span={9}>
                <ContentSection>
                  <ImageSection>
                    <Img src={printer.featuredImage} alt="" />
                  </ImageSection>
                  <ThumbnailImgSection>
                    <ThumbnailImgSection>
                      <ThumbnailImgWrapper>
                        <ThumbnailImg src={Ultimaker} alt=""></ThumbnailImg>
                      </ThumbnailImgWrapper>
                      <ThumbnailImgWrapper>
                        <ThumbnailImg src={Ultimaker} alt=""></ThumbnailImg>
                      </ThumbnailImgWrapper>
                      <ThumbnailImgWrapper>
                        <ThumbnailImg src={Ultimaker} alt=""></ThumbnailImg>
                      </ThumbnailImgWrapper>
                    </ThumbnailImgSection>
                  </ThumbnailImgSection>
                </ContentSection>
              </Col>
              <Col span={15}>
                <RightContentSection>
                  <ContentDiv>
                    <MediumHeaderTitle dark fontSize>
                      <strong>{printer.name}</strong>
                    </MediumHeaderTitle>
                    <ExpertText dark>
                      <strong>Brand:</strong>
                      <SpanX>{printer.brand}</SpanX>
                    </ExpertText>
                    <ExpertText dark>
                      <strong>Printer Dimensions LxWxH:</strong>
                      <SpanX>
                        {printer.length} x {printer.width} x {printer.height}
                      </SpanX>
                    </ExpertText>
                    {/* <ExpertText dark><strong>Printer Weight:</strong><SpanX>{printer.weight} Kilograms</SpanX></ExpertText> */}
                    {/* <ExpertText dark><strong>Supported File Format:</strong><SpanX>OBJ, STL, 3MF</SpanX></ExpertText>
                                    <ExpertText dark><strong>Material:</strong><SpanX>{printer?.material}</SpanX></ExpertText>
                                    <ExpertText dark><strong>Price:</strong><SpanX>{printer.price} per mm3</SpanX></ExpertText> */}
                    {/* <RatingDiv>
                                        <SectionX><strong style={{ paddingTop: '.2rem' }}>Rating:</strong><SpanX><Rate defaultValue={3}></Rate></SpanX><SpanX style={{ paddingTop: '.2rem' }}>7 Ratings</SpanX></SectionX>
                                    </RatingDiv> */}
                    <PrimaryButton
                      big
                      long
                      style={{ marginTop: "2rem" }}
                      onClick={() =>
                        history.push(`/dashboard/add/new/printer/${id}`)
                      }
                    >
                      edit
                    </PrimaryButton>
                  </ContentDiv>
                </RightContentSection>
              </Col>
            </Row>
            <SubHeaderDiv>
              <SmallText size small line bold>
                Designs made by this printer:
              </SmallText>
              <DivImage>
                <img src={Ultimaker} alt="" />
                <img src={Ultimaker} alt="" />
                <img src={Ultimaker} alt="" />
                <img src={Ultimaker} alt="" />
              </DivImage>
            </SubHeaderDiv>
            <InfoDiv>
              <Col span={7}>
                <SmallText size small line bold>
                  Seller Information:
                </SmallText>
                <SectionX>
                  <strong>Profile Name:</strong>
                  <SpanX>Lorem Ipsum Dolor</SpanX>
                </SectionX>
                <SectionX>
                  <strong>Rating:</strong>
                  <SpanX>
                    <Rate defaultValue={3} disabled></Rate>
                  </SpanX>
                </SectionX>
              </Col>
              <Col span={17} style={{ paddingTop: "2rem" }}>
                <Row>
                  <Col span={5}>
                    <SectionX>
                      <strong>Brief Information:</strong>
                    </SectionX>
                  </Col>
                  <Col span={12}>
                    <SectionX>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                      Maecenas leo lacus, ultrices at nisi eu, sodales feugiat
                      nisl.{" "}
                    </SectionX>
                  </Col>
                </Row>
              </Col>
            </InfoDiv>
            <RatingSection>
              <SmallText size small line bold>
                Rating & Review of Printer:
              </SmallText>
              <SectionA>
                <Rate
                  defaultValue={4}
                  style={{ paddingRight: "1rem" }}
                  disabled
                ></Rate>
                <MediumHeaderTitle dark>4.5/5</MediumHeaderTitle>
                <SpanX>7 Ratings</SpanX>
              </SectionA>
              <ReviewDiv>
                <SmallText size small line bold>
                  Reviews
                </SmallText>
              </ReviewDiv>
              <ReviewSection style={{ marginTop: "1rem", paddingLeft: "1rem" }}>
                <Col
                  span={5}
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <Rate defaultValue={3} disabled></Rate>
                  <SectionX>
                    by
                    <strong style={{ paddingLeft: ".2rem" }}>
                      Profile Name:
                    </strong>
                  </SectionX>
                  <SectionX>December 21, 2021</SectionX>
                </Col>
                <Col span={18} style={{ borderBottom: "1px solid #D8D8D8" }}>
                  <Reviews>
                    <SectionX>
                      Lorem ipsum dolor sit amet consectetur adipisicing elit.
                      Laudantium tempora voluptates cumque ex nisi. Praesentium
                      accusantium repellat repudiandae ipsa error, beatae ea
                      dolore dolorum fugiat cum cumque aliquid amet alias!
                    </SectionX>
                  </Reviews>
                </Col>
              </ReviewSection>
              <ReviewSection style={{ marginTop: "1rem", paddingLeft: "1rem" }}>
                <Col
                  span={5}
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <Rate defaultValue={3} disabled></Rate>
                  <SectionX>
                    by
                    <strong style={{ paddingLeft: ".2rem" }}>
                      Profile Name:
                    </strong>
                  </SectionX>
                  <SectionX>December 21, 2021</SectionX>
                </Col>
                <Col span={18} style={{ borderBottom: "1px solid #D8D8D8" }}>
                  <Reviews>
                    <SectionX>
                      Lorem ipsum dolor sit amet consectetur adipisicing elit.
                      Laudantium tempora voluptates cumque ex nisi. Praesentium
                      accusantium repellat repudiandae ipsa error, beatae ea
                      dolore dolorum fugiat cum cumque aliquid amet alias!
                    </SectionX>
                  </Reviews>
                </Col>
              </ReviewSection>
              <ReviewSection style={{ marginTop: "1rem", paddingLeft: "1rem" }}>
                <Col
                  span={5}
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <Rate defaultValue={3} disabled></Rate>
                  <SectionX>
                    by
                    <strong style={{ paddingLeft: ".2rem" }}>
                      Profile Name:
                    </strong>
                  </SectionX>
                  <SectionX>December 21, 2021</SectionX>
                </Col>
                <Col span={18}>
                  <Reviews>
                    <SectionX>
                      Lorem ipsum dolor sit amet consectetur adipisicing elit.
                      Laudantium tempora voluptates cumque ex nisi. Praesentium
                      accusantium repellat repudiandae ipsa error, beatae ea
                      dolore dolorum fugiat cum cumque aliquid amet alias!
                    </SectionX>
                  </Reviews>
                </Col>
              </ReviewSection>
              <Typography style={{ textAlign: "center", margin: "2rem 0" }}>
                <a href="all">View All Reviews</a>
              </Typography>
            </RatingSection>
          </ContentWrapper>
        </MainWrapper>
      </Spin>
    );
}

export default SinglePrinterPage;